import { render, staticRenderFns } from "./ConfirmDeleteSelection.vue?vue&type=template&id=6470cbd8"
import script from "./ConfirmDeleteSelection.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports